import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen">
      <div className="animated-bg"></div>

      {/* Hero Section */}
      <section className="pt-24 pb-14 px-4" data-testid="about-hero">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 fade-in">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              About <span className="neon-text">Research and Solution</span>
            </h1>
            <p className="text-base text-white/80 max-w-2xl mx-auto">
              Leading the way in sustainable water treatment solutions since 2003
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="slide-in-left">
              <img
                src="https://images.unsplash.com/photo-1528122819723-9dca3a31295d"
                alt="Environmental Protection"
                className="w-full rounded-2xl glass-card"
              />
            </div>
            <div className="slide-in-right">
              <div className="glass-card rounded-2xl p-6">
                <h2 className="text-xl font-bold text-white mb-4">Our Mission</h2>
                <p className="text-sm text-white/90 mb-3 leading-relaxed">
                  At Research and Solution, we are committed to providing innovative,
                  sustainable, and cost-effective solutions that protect the
                  environment and support industrial growth.
                </p>
                <p className="text-sm text-white/90 leading-relaxed">
                  With over two decades of experience, we have established ourselves as a trusted
                  partner for industries seeking reliable engineering and water management
                  solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Values */}
      <section className="py-14 px-4" data-testid="vision-values">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="glass-card rounded-2xl p-6" data-testid="vision-card">
              <div className="text-3xl mb-3"></div>
              <h2 className="text-xl font-bold text-white mb-4">Our Vision</h2>
              <p className="text-sm text-white/90 leading-relaxed">
                To become the global leader in water treatment technology, driving innovation and
                sustainability while creating a cleaner, healthier planet for future generations.
              </p>
            </div>
            <div className="glass-card rounded-2xl p-6" data-testid="values-card">
              <div className="text-3xl mb-3"></div>
              <h2 className="text-xl font-bold text-white mb-4">Our Values</h2>
              <ul className="space-y-2 text-sm text-white/90">
                <li className="flex items-start">
                  <span className="mr-2">&#10003;</span>
                  <span>Commitment to environmental sustainability</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">&#10003;</span>
                  <span>Innovation and continuous improvement</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">&#10003;</span>
                  <span>Customer-centric approach</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">&#10003;</span>
                  <span>Quality and reliability</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-14 px-4" data-testid="achievements">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Our <span className="neon-text">Achievements</span>
            </h2>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="glass-card rounded-xl p-5 text-center" data-testid="stat-projects">
              <div className="text-2xl md:text-3xl font-bold neon-text mb-1">200+</div>
              <p className="text-sm text-white/80">Projects Completed</p>
            </div>
            <div className="glass-card rounded-xl p-5 text-center" data-testid="stat-clients">
              <div className="text-2xl md:text-3xl font-bold neon-text mb-1">150+</div>
              <p className="text-sm text-white/80">Satisfied Clients</p>
            </div>
            <div className="glass-card rounded-xl p-5 text-center" data-testid="stat-experience">
              <div className="text-2xl md:text-3xl font-bold neon-text mb-1">22+</div>
              <p className="text-sm text-white/80">Years Experience</p>
            </div>
            <div className="glass-card rounded-xl p-5 text-center" data-testid="stat-countries">
              <div className="text-2xl md:text-3xl font-bold neon-text mb-1">10+</div>
              <p className="text-sm text-white/80">Industry categories Served</p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Impact */}
      <section className="py-14 px-4" data-testid="global-impact">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card rounded-2xl p-8 text-center">
            <img
              src="https://images.pexels.com/photos/4167579/pexels-photo-4167579.jpeg"
              alt="Global Environmental Impact"
              className="w-48 h-48 object-cover rounded-full mx-auto mb-6 neon-border"
            />
            <h2 className="text-2xl font-bold text-white mb-4">
              Making a <span className="neon-text">Global Impact</span>
            </h2>
            <p className="text-sm text-white/90 leading-relaxed max-w-2xl mx-auto">
              Through our advanced water treatment technologies and sustainable practices, we've
              helped industries reduce their environmental footprint, conserve
              water resources, and achieve regulatory compliance. Our commitment to excellence
              drives us to continuously innovate and deliver solutions that make a real difference.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="glass py-6 px-4 mt-14">
        <div className="max-w-6xl mx-auto text-center text-sm text-white/80">
          <p>&copy; 2025 Research and Solution. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About;
